import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import AuthFormWrapper from '../../auth/AuthFormWrapper'
import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import AppConfig from '../../../config/AppConfig'
import {useLocation} from 'react-router';

// Uncomment when we fix signed in state
// import Button from '../../shared/Button'
// import styled from 'styled-components'
// import colors from '../../../lib/Colors'
// import fonts from '../../../lib/Fonts'

// Uncomment when we fix signed in state
// const Header = styled.h2`
//   font-size: 1.75em;
//   color: ${colors.almostBlack};
//   font-family: ${fonts.family.lato};
//   margin: 0 0 1em;
//   font-weight: 300;
// `

const Login = ({
    setUrlParams,
    setCurrentUser,
    // Uncomment when we fix signed in state
    // username,
    // hasInviteLink,
    // acceptInvite
  }) => {
  const {pathname} = useLocation();
  const isSignIn = () => !(pathname === '/signup');

  useEffect(() => {
    setUrlParams()
    if (Cookies.get('userSessionIdentifier')) {
      try {
        const user = jwtDecode(Cookies.get('userSessionIdentifier'))
        if (user) {
          setCurrentUser(user)
        }
      }
      catch(err) {
        Cookies.remove('userSessionIdentifier', {domain: AppConfig.COOKIE_DOMAIN})
      }
    }
  }, [])
  return (
    <>
      {/*username && (
        <>
          <Header>Hey {username}!</Header>
          <Button
            onClick={() => {
              hasInviteLink ? acceptInvite() :
              window.location.href = `${AppConfig.LEGACY_BASE_URL}/account/dashboard`
            }}
            size={'large'}
          >
            Continue to Dashboard
          </Button>
          <Button
            onClick={() => {
              Cookies.remove('userSessionIdentifier', {domain: AppConfig.COOKIE_DOMAIN})
              setCurrentUser({})
            }}
            variation={'text'}
          >
            Not you?
          </Button>
        </>
          )*/}
      {/*!username && */} <AuthFormWrapper isLoginForm={isSignIn} />
    </>
  )
}

Login.propTypes = {
  acceptInvite: PropTypes.func,
  error: PropTypes.string,
  hasInviteLink: PropTypes.bool,
  setCurrentUser: PropTypes.func,
  setUrlParams: PropTypes.func,
  username: PropTypes.string,
}

Login.defaultProps = {
  error: 'no error',
}

export default Login
